import { render, staticRenderFns } from "./DesignLibrarySkeleton.vue?vue&type=template&id=385b7e0c&"
import script from "./DesignLibrarySkeleton.vue?vue&type=script&lang=js&"
export * from "./DesignLibrarySkeleton.vue?vue&type=script&lang=js&"
import style0 from "./DesignLibrarySkeleton.vue?vue&type=style&index=0&id=385b7e0c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports